import React, { useEffect, useState } from 'react';
import { Button } from '@arco-design/web-react';
import { maskPhone } from '../utils';

type PhoneCellProps = {
  phone?: string | null;
};

/** 手机号脱敏展示，可点击「查看」临时显示完整号码 */
function PhoneCell({ phone }: PhoneCellProps) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(false);
  }, [phone]);

  if (phone == null || String(phone).trim() === '') {
    return <span>-</span>;
  }

  const raw = String(phone).trim();

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, whiteSpace: 'nowrap' }}>
      <span>{visible ? raw : maskPhone(raw)}</span>
      <Button
        type="text"
        size="mini"
        style={{ padding: '0 4px', height: 'auto', lineHeight: 1.2 }}
        onClick={e => {
          e.stopPropagation();
          setVisible(v => !v);
        }}
      >
        {visible ? '隐藏' : '查看'}
      </Button>
    </span>
  );
}

export default PhoneCell;
